import React from 'react';
import { styles } from './BuyNowPayLater.css';
import { formatMoney } from '../../../../utils/FormatMoney';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag/useFeatureFlag';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { GemVisaIcon } from './GemVisaIcon';
import { LatitudePayIcon } from './LatitudePayIcon';
import { PaypalIcon } from './PaypalIcon';
import { ZipPayIcon } from './ZipPayIcon';
import { AfterpayIcon } from './AfterpayIcon';

type BNPLOption = {
  name: string;
  enabled: boolean;
  lowerLimit: number;
  upperLimit: number;
  url: string;
};

export type BuyNowPayLaterProps = {
  options: Array<BNPLOption>;
  productPrice: number;
};

const bnplIcons = {
  afterpay: <AfterpayIcon />,
  zip: <ZipPayIcon />,
  paypal: <PaypalIcon />,
  latitude: <LatitudePayIcon />,
  gem: <GemVisaIcon />,
};

const BuyNowPayLater = ({ options, productPrice }: BuyNowPayLaterProps) => {
  const shouldShowBNPLPrices = useFeatureFlag('shouldShowBNPLPrices');

  const elementIds = {
    wrapper: useIdPrefix('bnpl-wrapper'),
    afterpay: useIdPrefix('bnpl-afterpay'),
    zip: useIdPrefix('bnpl-zip'),
    paypal: useIdPrefix('bnpl-paypal'),
    gem: useIdPrefix('bnpl-gem'),
    latitude: useIdPrefix('bnpl-latitude'),
  };

  if (!options) return null;
  return (
    <div className={styles.wrapper} id={elementIds.wrapper}>
      {options.map((option, i) => {
        const shouldOptionShow =
          option.enabled && productPrice >= option.lowerLimit && productPrice <= option.upperLimit;
        if (shouldOptionShow) {
          const icon = bnplIcons[option.name as keyof typeof bnplIcons];
          const isZip = option.name === 'zip';
          return (
            <div className={styles.item} key={i} id={elementIds[option.name as keyof typeof elementIds]}>
              {option.url ? (
                <a target="_blank" className={styles.icon} rel="noreferrer" href={option.url}>
                  {icon}
                </a>
              ) : (
                <span className={styles.icon}>{icon}</span>
              )}
              {shouldShowBNPLPrices ? (
                <span>
                  {isZip ? (
                    <>
                      from
                      <br />
                      <b>$10/wk</b>
                    </>
                  ) : (
                    <>
                      4 payments
                      <br />
                      of <b>{formatMoney(productPrice / 4)}</b>
                    </>
                  )}
                </span>
              ) : null}
            </div>
          );
        }
      })}
    </div>
  );
};

export default BuyNowPayLater;
